module.exports = __webpack_public_path__ + "img/206-rwanda.e8cfe768.svg";